module.exports = __webpack_public_path__ + "img/Gisement.3466db47.svg";